export default {
    data() {
        return {
            qaList: [ //常见问题列表
                {
                    id: 1,
                    title: "U+联盟有什么功能",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>U+联盟是U+私人管家的商户端，合作商户可以在平台上接单、派单、发单。</p></div>",
                },
                {
                    id: 2,
                    title: "平台的收费是什么样",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>目前平台推广期间，客户／合作商户在平台上发单全免费。</p></div>" +
                        "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>合作商户在平台上成功接单后，按服务人员月工资的4%计费。</p></div>",
                },
                {
                    id: 3,
                    title: "如何管理客户",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>客户选择您的服务师后，您负责对订单及服务师进行管理。</p></div>" +
                        "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>我们的私人管家是一对一服务客户，她会协助您服务好客户。</p></div>",
                },
                {
                    id: 4,
                    title: "客户下单的流程是什么",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'>1.</span><p>客户可以通过平台发布需求，寻找合适的服务人员</p></div>" +
                        "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'>2.</span><p>合作商户看到客户的订单，推荐合适的服务人员，客户进行选择</p></div>" +
                        "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'>3.</span><p>客户选择你的服务人员后，平台将客户的联系方式和地址发送给你，同时也会通知您的服务人员和您联系，您带服务人员上门为客户提供服务。</p></div>",
                },
                {
                    id: 5,
                    title: "合作商户是否可以在平台上发布订单呢？与微信相比，有什么优势",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>可以。</p></div>" +
                        "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>平常您的订单往往通过微信群、朋友圈的方式发布，需要不断的刷新，才能被其他合作商户看到。</p></div>" +
                        "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>现在您可以通过U+联盟进行免费发单。平台会通过短信或app消息的方式即时发送给全城合作商户，全市700多家合作商户都会收到客户／合作商户的订单，并选择是否响应。</p></div>",
                },
                {
                    id: 6,
                    title: "发布一个订单多久能有回复",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>一笔订单的最长显示时间为24小时，一般来说2个小时就会有合作商户响应。如果订单超过24小时还没有人响应，系统自动关闭，客户／合作商户可以选择重新发布订单，或者删除该订单。</p></div>",
                },
                {
                    id: 7,
                    title: "服务人员的工资如何支付",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><p>服务人员的工资由客户直接支付给服务人员。</p></div>",
                },
                {
                    id: 8,
                    title: "服务区域有哪些",
                    content: "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'>1.</span><p>目前我们已覆盖上海全部区域。</p></div>" +
                        "<div class='item' style='width:100%;padding:0.2rem 0 0.1rem;display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;'><span class='bullet'>2.</span><p>我们即将开通杭州，北京。</p></div>",
                },
            ],
            isShowDetail: false, //是否显示详情
            curDetail: {}, //当前详情
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'serviceHelp') {
                this.init();
            }
        }
    },
    methods: {
        init() {
            this.isShowDetail = false;
        },
        //展示详情开关
        switchDetail(item) {
            if (item && item.id) {
                this.curDetail = JSON.parse(JSON.stringify(item));
            }
            this.isShowDetail = !this.isShowDetail;
        }
    },
}


// WEBPACK FOOTER //
// ./src/ally/page/service/help.js